module.exports = __webpack_public_path__ + "static/img/8.5a46433.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/eng/8.png
// module id = kqXo
// module chunks = 0